import { asyncComponentFactory } from '@utils';

const AppComponents = {
  // UI Components ------------------------------------------------------------
  Accordion: asyncComponentFactory('ui/Accordion'),
  Drawer: asyncComponentFactory('ui/Drawer'),
  FeaturesAndBenefitsSlider: asyncComponentFactory('ui/FeaturesAndBenefitsSlider'),
  Slider: asyncComponentFactory('ui/Slider'),
  MiniCart: asyncComponentFactory('ui/MiniCart'),
  MainCart: asyncComponentFactory('ui/Cart/MainCart'),
  Modal: asyncComponentFactory('ui/Modal'),
  ProductForm: asyncComponentFactory('ui/ProductForm'),
  ProductVariantSelector: asyncComponentFactory('ui/VariantSelector'),
  ExternalVariantSelector: asyncComponentFactory('ui/ExternalVariantSelector'),
  EcoBadge: asyncComponentFactory('ui/EcoBadge'),
  ['product-gallery']: asyncComponentFactory('ui/ProductGallery'),
  ProductRecommendations: asyncComponentFactory('ui/ProductRecommendations'),
  QuickSearch: asyncComponentFactory('ui/QuickSearch'),
  MobileSearch: asyncComponentFactory('ui/MobileSearch'),
  Tabs: asyncComponentFactory('ui/Tabs'),

  // MEDIA Components ------------------------------------------------------------
  ResponsiveVideo: asyncComponentFactory('media/ResponsiveVideo'),
  ['video-player']: asyncComponentFactory('media/VideoPlayer'),

  // NAV Components ------------------------------------------------------------
  DesktopNav: asyncComponentFactory('nav/DesktopNav'),
  MobileNav: asyncComponentFactory('nav/MobileNav'),
};

export default AppComponents;
